import React, {useEffect, useMemo, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Button} from "primereact/button";
import {setActiveClick} from "redux/actions/actions";
import {getMonitoringExcel, updateUserFields} from "../../../redux/api/apiMonitoringList";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {ToggleButton} from "primereact/togglebutton";
import {autoReloadToggle} from "../../../redux/actions/actionsMonitoringList";
import {MultiSelect} from "primereact/multiselect";
import {OverlayPanel} from "primereact/overlaypanel";
import {Tag} from "primereact/tag";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {withMonitoringBranchIdSortField} from "../../../redux/api/sortFieldsFetchState";
import {getHashPath} from "../../../utils/encodedUrlQuery";
import CampaignLeadsStats from "../../Statistics/CampaignLeadsList/CampaignLeadsStats";

const MonitoringListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const exportLoading = useAppSelector(state => state.MonitoringListReducer.exportLoading);
    const autoReload = useAppSelector(state => state.MonitoringListReducer.autoReload);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const monitoringPermissions = checkPermissions(rolesVision, 'Monitoring');
    const rawUserSortFields: any = useAppSelector(state => state.RolesReducer?.userSortFields);
    const sortFields = useMemo(
        () => withMonitoringBranchIdSortField(rawUserSortFields)?.fields ?? [],
        [rawUserSortFields]
    );
    const [selectedFields, setSelectedFields] = useState<any>(sortFields);
    const op = useRef<OverlayPanel>(null);
    const {
        update: hasUpdatePermission,
    } = monitoringPermissions;

    let filteredObject = {
        "sort": props.sortData?.sort,
        "filter": props.sortData?.filter
    };

    useEffect(() => {
        setSelectedFields(sortFields);
    }, []);

    useEffect(() => {
        setSelectedFields(sortFields);
    }, [sortFields]);

    const onColumnToggle = (e: { value: { name: any; }[]; }) => {
        const updatedFields = selectedFields.map((field: { name: any; inSystem: any; }) => {
            if (!field.inSystem) {
                return {
                    ...field,
                    isActive: e.value.some((selected: { name: any; }) => selected.name === field.name)
                };
            }
            return field;
        });
        setSelectedFields(updatedFields);
    };

    const saveUserFields = () => {
        dispatch(updateUserFields(selectedFields, jwtToken?.jwtToken));
    };

    const itemTemplate = (option: any) => {
        let itemName:string;
        switch (option.name) {
            case "ani":
                itemName = 'Клiент';
                break;
            case "aNumber":
                itemName = 'Транк';
                break;
            case "ownerUserName":
                itemName = 'Власник дзвінка';
                break;
            case "fullName":
                itemName = 'Оператор';
                break;
            case "direction":
                itemName = 'Тип Активності';
                break;
            case "campaignFullName":
                itemName = 'ID / Назва Кампанii';
                break;
            case "branchId":
                itemName = 'ID / Branch';
                break;
            case "queueFullName":
                itemName = 'ID / Назва Черги';
                break;
            case "status":
                itemName = 'Статус';
                break;
            case "callType":
                itemName = 'Активність';
                break;
            case "ownerType":
                itemName = 'Тип власника';
                break;
            case "callResetName":
                itemName = 'Завершив';
                break;
            case "forcedClosing":
                itemName = 'Причина завершення';
                break;
            case "start":
                itemName = 'Початок';
                break;
            case "duration":
                itemName = 'Тривалість розмови';
                break;
            case "fullCallDuration":
                itemName = 'Тривалість дзвінка';
                break;
            case "reactionClient":
                itemName = 'Реакція Клієнта';
                break;
            case "reactionOperator":
                itemName = 'Реакція Оператора';
                break;
            case "end":
                itemName = 'Завершення';
                break;
            case "contactName":
                itemName = 'Контакт';
                break;
            default:
                itemName = option.name;
        }

        return (
            <div className="custom-item">
                <span>{itemName}</span>
            </div>
        );
    }

    const selectedItemTemplate = (option: any) => {
        if (!option) {
            return <p className="opacity-50">Нічого не обрано</p>;
        }

        let itemName:string;

        switch (option.name) {
            case "ani":
                itemName = 'Клiент';
                break;
            case "aNumber":
                itemName = 'Транк';
                break;
            case "ownerUserName":
                itemName = 'Власник дзвінка';
                break;
            case "fullName":
                itemName = 'Оператор';
                break;
            case "direction":
                itemName = 'Тип Активності';
                break;
            case "campaignFullName":
                itemName = 'ID / Назва Кампанii';
                break;
            case "branchId":
                itemName = 'ID / Branch';
                break;
            case "queueFullName":
                itemName = 'ID / Назва Черги';
                break;
            case "status":
                itemName = 'Статус';
                break;
            case "callType":
                itemName = 'Активність';
                break;
            case "ownerType":
                itemName = 'Тип власника';
                break;
            case "callResetName":
                itemName = 'Завершив';
                break;
            case "forcedClosing":
                itemName = 'Причина завершення';
                break;
            case "start":
                itemName = 'Початок';
                break;
            case "contactName":
                itemName = 'Контакт';
                break;
            default:
                itemName = option.name;
        }

        return <Tag
            value={itemName}
            className="custom-chip"
        ></Tag>;
    };


    const onRowReorder = (e: { dragIndex: number; dropIndex: number; }) => {
        let updatedRows = [...selectedFields];
        const draggedRow = updatedRows[e.dragIndex];

        updatedRows.splice(e.dragIndex, 1);
        updatedRows.splice(e.dropIndex, 0, draggedRow);

        updatedRows = updatedRows.map((row, index) => ({
            ...row,
            order: index + 1
        }));

        setSelectedFields(updatedRows);
    }

    const handleDelete = (index: number) => {
        const updatedFields = selectedFields.map((field: any, i: number) =>
            i === index ? { ...field, isActive: false } : field
        );
        setSelectedFields(updatedFields);
    }

    const columnGroupItems = () => {
        const filteredData = selectedFields
            ?.filter(
                (field: { isActive: boolean;}) =>
                    field.isActive
            )
            ?.sort((a: { order: number }, b: { order: number }) => a.order - b.order);

        const normalizeDisplayOrder = (array: any[]) => {
            return array?.map((item, index) => ({
                ...item,
                order: index + 1,
            }));
        };

        const filteredArray = normalizeDisplayOrder(filteredData);

        const nameField = (rowData: any) => {
            let itemName:string;

            switch (rowData.name) {
                case "ani":
                    itemName = 'Клiент';
                    break;
                case "aNumber":
                    itemName = 'Транк';
                    break;
                case "ownerUserName":
                    itemName = 'Власник дзвінка';
                    break;
                case "fullName":
                    itemName = 'Оператор';
                    break;
                case "direction":
                    itemName = 'Тип Активності';
                    break;
                case "campaignFullName":
                    itemName = 'ID / Назва Кампанii';
                    break;
                case "branchId":
                    itemName = 'ID / Branch';
                    break;
                case "queueFullName":
                    itemName = 'ID / Назва Черги';
                    break;
                case "status":
                    itemName = 'Статус';
                    break;
                case "callType":
                    itemName = 'Активність';
                    break;
                case "ownerType":
                    itemName = 'Тип власника';
                    break;
                case "callResetName":
                    itemName = 'Завершив';
                    break;
                case "forcedClosing":
                    itemName = 'Причина завершення';
                    break;
                case "start":
                    itemName = 'Початок';
                    break;
                case "duration":
                    itemName = 'Тривалість розмови';
                    break;
                case "fullCallDuration":
                    itemName = 'Тривалість дзвінка';
                    break;
                case "reactionClient":
                    itemName = 'Реакція Клієнта';
                    break;
                case "reactionOperator":
                    itemName = 'Реакція Оператора';
                    break;
                case "end":
                    itemName = 'Завершення';
                    break;
                case "contactName":
                    itemName = 'Контакт';
                    break;
                default:
                    itemName = rowData.name;
            }

            return <p className="m-0">{itemName}</p>;
        }

        const buttonTemplate = (rowData: any, columnProps: any) => {
            const originalIndex = selectedFields.findIndex((field: any) => field.name === rowData.name);
            return !rowData?.inSystem ? (
                <Button
                    onClick={() => handleDelete(originalIndex)}
                    icon="pi pi-times"
                    className="delete-user p-button-secondary p-button-rounded p-button-text field col-12 md:col-2 mb-0 px-0"
                    disabled={!hasUpdatePermission}
                />
            ) : <></>;
        }

        return <DataTable className="w-full table-selected-fields" value={filteredArray} reorderableColumns reorderableRows
                          onRowReorder={onRowReorder}>
            <Column className="custom-column-width-20" rowReorder style={{width: '20px', maxWidth: '20px'}}/>
            <Column field="order" className="text-center" style={{minWidth: '10px', width: '40px', maxWidth: '40px'}}/>
            <Column field="name" body={nameField} style={{minWidth: '50%', maxWidth: '70%', justifyContent: 'flex-start'}}/>
            <Column body={buttonTemplate} style={{width: '20px', padding: 0, maxWidth: '20px'}}/>
        </DataTable>
    };

    return (
        <>
        <div className="table-buttons">
            <div className="text-normal-weight">
                <ToggleButton style={{fontWeight: 'normal'}} onLabel={'Мої активності'} offLabel={'Всі'} checked={props.activity} onChange={() => {
                    props.setActivity(!props.activity);
                    props.setToggleButtonActivity(!props.toggleButtonActivity);
                    props.activityChangedManuallyRef.current = true;
                }} className="w-10rem mb-2 mr-2 font-normal"/>

                <ToggleButton style={{fontWeight: 'normal'}} onLabel={'Автооновлення'} offLabel={'Ручне оновлення'} checked={autoReload}
                              onChange={(e) => {
                                  dispatch(autoReloadToggle(!autoReload));
                                  if (e.target.value) {
                                      dispatch(setActiveClick({item: '/monitoring', from: getHashPath(window.location.hash), click: true}));
                                  }
                              }}
                              className="w-10rem mb-2 mr-2 font-normal"/>

                <Button className="mb-2" type="button" icon="pi pi-cog"
                        onClick={(e) => {
                            // @ts-ignore
                            op.current.toggle(e);
                            setSelectedFields(sortFields);

                        }}/>
                <OverlayPanel ref={op}>
                    <div className="flex flex-column">
                        <div className="mb-3 text-bold">Виберіть стовпці для відображення:</div>
                        <MultiSelect
                            value={selectedFields?.filter((field: any) => !field.inSystem && field?.isActive)}
                            options={selectedFields?.filter((field: { inSystem: any }) => !field.inSystem)}
                            optionLabel="name"
                            onChange={onColumnToggle}
                            className="w-full mb-2 sm:max-w-20rem max-w-14rem"
                            display="chip"
                            filter
                            selectedItemTemplate={selectedItemTemplate}
                            itemTemplate={itemTemplate}
                        />
                        {
                            selectedFields?.length ?
                                <div className="users-list">
                                    {columnGroupItems()}
                                </div>
                                :
                                <span className="no-users-message">Груп не обрано</span>
                        }


                        <div className="flex justify-content-between field mt-2 mb-0">
                            <Button icon="pi pi-times" className="p-button p-component p-button-secondary p-button-icon-only" onClick={(e) =>{
                                if (op.current) {
                                    op.current.toggle(e);
                                }
                            }}></Button>
                            <Button icon="pi pi-check" onClick={() => {
                                saveUserFields();
                                if (op.current) {
                                    op.current.hide();
                                }
                            }}></Button>
                        </div>
                    </div>
                </OverlayPanel>
            </div>
            <div className="desktop">
                {hasUpdatePermission && <Button onClick={() => dispatch(getMonitoringExcel(filteredObject, jwtToken?.jwtToken))}
                                                label="Експорт таблиці"
                                                loading={exportLoading}
                                                icon="pi pi-file-excel"
                                                style={{backgroundColor: '#1d6f42'}}
                                                className="mr-2 mb-2 p-button-success text-white shadow-none"
                />}
                <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри" className="p-button-outlined mr-2 mb-2" onClick={() => {
                    props.resetSorting()
                }}/>
            </div>
            <div className="mobile">
                {hasUpdatePermission && <Button onClick={() => dispatch(getMonitoringExcel(filteredObject, jwtToken?.jwtToken))}
                                                icon="pi pi-file-excel"
                                                loading={exportLoading}
                                                style={{backgroundColor: '#1d6f42'}}
                                                className="mr-2 mb-2 p-button-success text-white shadow-none"
                />}
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2" onClick={() => props.resetSorting()}/>
            </div>
        </div>
        <CampaignLeadsStats variant="monitoring"/>
        </>
    )
}

export default MonitoringListNav;
